import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';

import { mapReferencePrice, RawReferencePrice } from './mapReferencePrice';
import Product from './Product';

export interface RawProduct {
	allowsEmptyCalculator: { exFactory: boolean };
	packageSizeForCalculation: number | null;
	packageSizeForSingleUnit: number | null;
	product: RawGeneralProduct;
	referenceDataSource: boolean;
	referencePrices: RawReferencePrice[];
	selectable: boolean;
	selected: boolean;
	singleUnitPackageSize: boolean;
}

export default function mapProduct(product: RawProduct): Product {
	return new Product(
		product.allowsEmptyCalculator,
		product.packageSizeForCalculation,
		product.packageSizeForSingleUnit,
		mapGeneralProduct(product.product),
		product.referenceDataSource,
		product.referencePrices.map(mapReferencePrice),
		product.selectable,
		product.selected,
		product.singleUnitPackageSize
	);
}
